import {
  DatabaseRowDataFunctions_getRowDataWithMaxCountsForDatabase,
  DatabasesByTagQueryGql,
  DatabasesDefaultDirections,
  DatabasesDefaultSortField,
  DatabasesDisplayGridRowData,
  DatabasesExplorerQueryGrid_mapResultNodeWithTagFilter,
  DatabasesExplorerQueryGrid_QueryResultListNode,
  DatabasesExplorerQueryGrid_QueryResultListNodeWithTagFilter,
  DatabasesExplorerQueryGrid_QueryResults,
  DatabasesExplorerQueryGrid_QueryResultsWithTagFilter,
  DatabasesExplorerQueryGrid_QueryVariables,
  DatabasesExplorerQueryGrid_QueryVariablesWithTagFilter,
  DatabasesExplorerQueryGrid_selectConnectionListResult,
  DatabasesExplorerQueryGrid_selectConnectionListResultWithTagFilter,
  DatabasesQueryGql,
  GraphQLGlobalTypes,
} from '@tableau/data-catalog-client-components';
import { defaultMemoize } from 'reselect';
import { ISliceable } from '../../ts/models/ISliceable';
import { catalogApolloClient } from '../CatalogApolloClient';
import { BaseGraphQLResourceQuery } from './BaseGraphQLResourceQuery';
import { getExplorerGraphQLFilters } from './CatalogFilterClauseHelpers';
import { getSortOrderOrDefault } from './CatalogOrderClauseHelpers';
import { makeSliceableFactoryForGraphQLQuery } from './GraphQLSliceable';


const getDefaultSliceableFactorySingleton = defaultMemoize(() => {
  return makeSliceableFactoryForGraphQLQuery<
    DatabasesExplorerQueryGrid_QueryResultListNode,
    DatabasesDisplayGridRowData,
    DatabasesExplorerQueryGrid_QueryVariables,
    DatabasesExplorerQueryGrid_QueryResults
    >(
    {
      queryGql: DatabasesQueryGql,
      selectConnectionListResult: DatabasesExplorerQueryGrid_selectConnectionListResult,
      mapResultNode: DatabaseRowDataFunctions_getRowDataWithMaxCountsForDatabase,
    },
    catalogApolloClient
  );
});

const getTagFilteredSliceableFactorySingleton = defaultMemoize(() => {
  return makeSliceableFactoryForGraphQLQuery<
    DatabasesExplorerQueryGrid_QueryResultListNodeWithTagFilter,
    DatabasesDisplayGridRowData,
    DatabasesExplorerQueryGrid_QueryVariablesWithTagFilter,
    DatabasesExplorerQueryGrid_QueryResultsWithTagFilter
    >(
    {
      queryGql: DatabasesByTagQueryGql,
      selectConnectionListResult: DatabasesExplorerQueryGrid_selectConnectionListResultWithTagFilter,
      mapResultNode: DatabasesExplorerQueryGrid_mapResultNodeWithTagFilter,
    },
    catalogApolloClient
  );
});

export class DatabasesGraphQLResourceQuery
  extends BaseGraphQLResourceQuery<DatabasesDisplayGridRowData> {

  protected makeSliceable(): ISliceable<DatabasesDisplayGridRowData> {
    const orderBy = getSortOrderOrDefault(this.getOrder(), DatabasesDefaultSortField, DatabasesDefaultDirections);
    const filterParameters = getExplorerGraphQLFilters(this.getFilters());

    const partialQueryVariables = {
      orderBy: orderBy as GraphQLGlobalTypes.DatabaseSortOrder,
      textSearch: filterParameters.search,
      hasActiveWarning: filterParameters.hasActiveWarning,
      isCertified: filterParameters.isCertified,
    };


    const sliceable = filterParameters.tags
      ? getTagFilteredSliceableFactorySingleton()({ tagName: filterParameters.tags, ...partialQueryVariables })
      : getDefaultSliceableFactorySingleton()(partialQueryVariables);

    return sliceable;
  }
}
